import React from 'react';
import ReactDOM from 'react-dom';
import { Auth0Provider } from "@auth0/auth0-react";
import './index.css';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Auth0Provider
    domain={String(process.env.REACT_APP_AUTH0_DOMAIN)}
    clientId={String(process.env.REACT_APP_AUTH0_CLIENT_ID)}
    redirectUri={window.location.origin + process.env.REACT_APP_AUTH0_REDIRECT_PATH}
    audience={process.env.REACT_APP_AUTH0_API_IDENTIFIER}
    cacheLocation="localstorage"
  >
    <App />
  </Auth0Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
